export default class DTO<T> {
  constructor(obj: T) {
    Object.assign(this, obj);
  }
}
